import { DESIGN_HEIGHT, DESIGN_WIDTH, toPoints } from '../geometry';
import { regionOutline } from './regions';
import type { ArtProps, SceneRegion, ScenePhotoSlot } from './types';

/** The photograph behind the stone (replaces the drawn `Back` layer). */
export function PhotoBack({ photo }: { photo: ScenePhotoSlot }) {
  return (
    <image
      href={photo.src}
      x="0"
      y="0"
      width={DESIGN_WIDTH}
      height={DESIGN_HEIGHT}
      preserveAspectRatio="xMidYMid slice"
    />
  );
}

/** Objects that stand in front of the stone, cut out of the photograph (replaces the drawn `Front`). */
export function PhotoFront({ photo }: { photo: ScenePhotoSlot }) {
  return photo.foreground ? (
    <image
      href={photo.foreground}
      x="0"
      y="0"
      width={DESIGN_WIDTH}
      height={DESIGN_HEIGHT}
      preserveAspectRatio="xMidYMid slice"
    />
  ) : null;
}

/** A generic soft falloff for photographs, which carry their own lighting: only the edges are eased. */
export function PhotoShade({ ids, regions }: ArtProps & { regions: readonly SceneRegion[] }) {
  const id = `${ids}-photo-shade`;
  return (
    <g>
      <defs>
        <radialGradient
          id={id}
          cx="600"
          cy="400"
          r="760"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(600 400) scale(1 0.7) translate(-600 -400)"
        >
          <stop offset="0.55" stopColor="#000" stopOpacity="0" />
          <stop offset="1" stopColor="#000" stopOpacity="0.4" />
        </radialGradient>
      </defs>
      {regions.map((region) => (
        <polygon key={region.id} points={toPoints(regionOutline(region))} fill={`url(#${id})`} />
      ))}
    </g>
  );
}
